import { render, staticRenderFns } from "./ExRedSpinner.vue?vue&type=template&id=0ef1b2a6&scoped=true"
import script from "./ExRedSpinner.vue?vue&type=script&lang=js"
export * from "./ExRedSpinner.vue?vue&type=script&lang=js"
import style0 from "./ExRedSpinner.vue?vue&type=style&index=0&id=0ef1b2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef1b2a6",
  null
  
)

export default component.exports